<div class="relative w-full h-full overflow-hidden">
	<summary-start-page
		class="absolute w-full h-full transition-all duration-1000 ease-in-out"
		[class.-translate-x-full]="currentSlideIndex() > 0"
		[year]="year()"
	></summary-start-page>
	<div
		class="absolute w-full h-full left-0 transition-all duration-1000 ease-in-out"
		[class.-translate-x-full]="currentSlideIndex() > 4"
		[class.translate-x-full]="currentSlideIndex() === 0"
		id="summary-of-the-year-single-vehicle-overview"
	>
		<div
			class="absolute flex flex-col justify-center items-center text-secondary-800 bg-primary-300 transition-all duration-1000 left-0"
			[class]="{
				'w-full': currentSlideIndex() < 2,
				'w-1/2': currentSlideIndex() >= 2,
				'h-full': currentSlideIndex() < 4,
				'h-1/2': currentSlideIndex() >= 4,
			}"
		>
			<div class="text-4xl">{{ 'summary.busytime' | translate }}</div>
			<div class="font-bold text-6xl xl:text-8xl 3xl:text-9xl">
				{{ this.vehicleData().busyAbs | seconds: true : true }}
			</div>
		</div>
		<div
			class="absolute flex flex-col w-1/2 justify-center items-center text-secondary-800 bg-[#FFEF90] transition-all duration-1000 right-0"
			[class]="{
				'translate-x-full': currentSlideIndex() < 2,
				'h-full': currentSlideIndex() < 3,
				'h-1/2': currentSlideIndex() >= 3,
			}"
		>
			<div class="text-4xl">{{ 'summary.weight' | translate }}</div>
			<div class="font-bold text-6xl xl:text-8xl 3xl:text-9xl">
				{{ this.vehicleData().weightAbs | weight: false }}
			</div>
		</div>
		<div
			class="absolute flex flex-col w-1/2 h-1/2 justify-center items-center text-secondary-800 bg-[#FFFAE0] transition-all duration-1000 right-0 bottom-0"
			[class]="{
				'translate-y-full': currentSlideIndex() < 3,
			}"
		>
			<div class="text-4xl">{{ 'summary.distance' | translate }}</div>
			<div class="font-bold text-6xl xl:text-8xl 3xl:text-9xl">
				{{ this.vehicleData().distanceAbs | distance }}
			</div>
		</div>
		<div
			class="absolute flex flex-col w-1/2 h-1/2 justify-center items-center text-secondary-800 bg-[#FFF4B5] transition-all duration-1000 left-0 bottom-0"
			[class]="{
				'translate-y-full': currentSlideIndex() < 4,
			}"
		>
			<div class="text-4xl">{{ 'summary.pickups' | translate }}</div>
			<div class="font-bold text-6xl xl:text-8xl 3xl:text-9xl">
				{{ this.vehicleData().pickupCnt | customNumber }}
			</div>
		</div>
		<summary-overview-label
			class="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 hidden"
			id="summary-of-the-year-single-vehicle-overview-label"
			[year]="year()"
		>
		</summary-overview-label>
	</div>
	<summary-download-page
		class="absolute w-full h-full transition-all duration-1000 right-0 ease-in-out"
		[class.translate-x-full]="currentSlideIndex() < totalSlides - 1"
		[year]="year()"
		overviewPageId="summary-of-the-year-single-vehicle-overview"
		overviewLabelId="summary-of-the-year-single-vehicle-overview-label"
	>
	</summary-download-page>

	<summary-navigation
		class="absolute bottom-8 left-1/2 -translate-x-1/2 z-10"
		[numberOfSlides]="totalSlides"
		[(currentSlideIndex)]="currentSlideIndex"
	></summary-navigation>
	<ui-button
		type="link-dark"
		icon="x_cross"
		iconSize="l"
		class="absolute top-8 right-8 z-10"
		[styleClass]="
			currentSlideIndex() === 0 || currentSlideIndex() === totalSlides - 1
				? 'text-white!'
				: 'text-secondary-500!'
		"
		(buttonClicked)="closeSummary()"
	></ui-button>
</div>
